import React from 'react';
import FullPaymentForm from './FullPaymentForm';
import PartialPaymentForm  from './PartialPaymentForm';
import axios from '../../../../constants/axios.js';
import { Tabs, Tab } from 'react-bootstrap';

class PurchasePayBill extends React.Component {

   constructor(props) {
      super(props);

      this.state = {
         billInfo: {},
         tabActiveKey: 1,
         paymentAccounts: []
      };
   }

   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`inventoryPurchases/billInformation/${invoiceId}`)
         .then((res) => {
            this.setState({
               billInfo: res.data
            });
         });
   }

   changeTabChange = (key) => {
      this.setState({
         tabActiveKey: key
      });
   };

   changeRoute = (link) => {
      this.context.router.push(link);
   };


   render() {
      const { invoiceId } = this.props.params;
      const { billInfo } = this.state;
      return (
         <div>
            <div>
               <p>Bill id: {billInfo.id}</p>
               <p>Contact Name: {billInfo.contact_name}</p>
               <p>Bill Amount: {billInfo.amount}</p>
               <p>Bill Due: {billInfo.amount_due}</p>
            </div>
            <hr/>
            <Tabs activeKey={this.state.tabActiveKey} onSelect={this.changeTabChange} id="purchase-pay" >
               <Tab eventKey={1} title="Full Payment" >
                  <FullPaymentForm invoiceId={invoiceId} changeRoute={this.changeRoute} />
               </Tab>
               <Tab eventKey={2} title="Partial Payment" >
                  <PartialPaymentForm invoiceId={invoiceId} changeRoute={this.changeRoute} />
               </Tab>
            </Tabs>
         </div>
      );
   }
}

PurchasePayBill.propTypes = {
   params: React.PropTypes.object,
   children: React.PropTypes.object
};

PurchasePayBill.contextTypes = {
   router: React.PropTypes.object
};

export default PurchasePayBill;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Purchase/PurchasePayment/PurchasePayBill.js
 **/